import { createAction } from '@reduxjs/toolkit';
import { RequestError, HistoricPendingCommunication, CommunicationsPendingHistoryForm } from 'types';

export const fetchHistoricPendingCommunication = createAction(
  'historic-pending-communication/fetch',
  (pendingCommunication: CommunicationsPendingHistoryForm) => ({
    payload: pendingCommunication,
  })
);

export const fetchedHistoricPendingCommunication = createAction(
  'historic-pending-communication/fetched',
  (data?: HistoricPendingCommunication, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export const deleteHistoricPendingCommunication = createAction(
  'historic-communication/delete-historic-pending-communication',
  (ids: number[]) => ({
    payload: { communicationsIDs: ids },
  })
);

export const deletedHistoricPendingCommunication = createAction(
  'historic-communication/deleted-historic-pending-communication',
  (data?: boolean, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchHistoricPendingCommunication,
  fetchedHistoricPendingCommunication,
  deleteHistoricPendingCommunication,
  deletedHistoricPendingCommunication,
};
